import { isPhone } from '../utils/base-init.js'
import { barbaMarkup } from '../utils/func.js'
import './fast-payment.js'

import {
	cloneSurvey,
	surveyBlockEffect,
	surveyBtnEffect,
} from '../utils/survey-btn-effect.js'
import { swalBlankOption } from '../components/swal-opt.js'

import { fetchReferralContent } from '../components/referral.js'
import trigerPromotionChanel from './trigerPromotionChanel.js'
import submitSurvey from '../utils/submitSurvey.js'
import useUrlParameter from '../utils/useUrlParameter.ts'
import triggerSyzpModalSlide from '../components/triggerSyzpModalSlide.js'
import { saveGeolocation } from '../components/getGeolocation.js'


export function fb_share(shareLink) {
	const u = shareLink.split('//')[1]
	// const t = $('#share-message').text()
	console.log(u)
	window.open(
		'//www.facebook.com/sharer.php?u=' + encodeURIComponent(u),
		'sharer',
		'toolbar=0,status=0,width=560,height=392,scrollbars=no'
	)
}

export function tweet_share(shareLink) {
	const text = $('#share-message').text()
	// const url = escape($('#data-share-url').attr('data-share-url'))
	const tweet =
		'//twitter.com/intent/tweet?source=webclient&text=' +
		text +
		'+--+' +
		shareLink
	window.open(tweet, 'Tweeter', 'toolbar=0,status=0,width=626,height=436')
}

const hideModal = () => {
	$('#survey-holder-wrapper').modal('hide')
}

export function submitSurveyAction(
	data = $('#survey-placeholder').serialize(),
	needToHideModal = true
) {
	if (needToHideModal) hideModal()
	submitSurvey(data)
}

function noBackButton() {
	history.pushState(null, null, location.href)
	return (window.onpopstate = function () {
		history.go(1)
	})
}

function popupSurvey() {
	const orderNumber = $('#order-summary-order-number').text()
	$('#survey-header-order-number').html(orderNumber)
	if (isPhone) {
		$('#survey-holder-wrapper')
			.modal()
			.on('shown.bs.modal', () => {
				$('body').addClass('survey-modal-is-open')
			})
			.on('hide.bs.modal', () => {
				$('body').removeClass('survey-modal-is-open')
			})
	} else {
		$('#survey-holder-wrapper')
			.modal(
				{
					backdrop: 'static',
					keyboard: false,
				},
				'show'
			)
			.on('shown.bs.modal', () => {
				noBackButton()
			})
	}
}

function testPopupSurvey() {
	cloneSurvey()
	popupSurvey()
	surveyBtnEffect()
	surveyBlockEffect()
}

function showSurvey() {
	if (window.unfinishedSurvey) {
		popupSurvey()
	} else {
		if (!isPhone) {
			noBackButton()
		}
	}
}

async function popupReferral(orderId) {
	// btnLoadingStart('.CopyButton--wrapper')

	// const description = await getMeta('og:description')
	// eslint-disable-next-line new-cap
	const content = await fetchReferralContent(orderId)
	// const content = await fetchContent('/referral/index/ajax-invite?ajax=1')

	Swal.fire(swalBlankOption(content, false, true, 'referral-container-class')).then((result) => {
		// btnLoadingDone('.CopyButton--wrapper')
		if (result.value) {
			// alert('test')
		}
	})
}

export const Confirmation = {
	namespace: 'confirmation',
	beforeEnter(data) {
		const trigerPC = useUrlParameter(window.location.href, 'pc')
		barbaMarkup('confirmation')
		if (!window.unfinishedSurvey && trigerPC) {
			trigerPromotionChanel()
		} else if (window.orderSummary.orderSummarySlideIn === '1' && window.innerWidth > 767) {
			 setTimeout(triggerSyzpModalSlide, 3000)
		}

		$('#mobile-header-timer-seating-chart').TimeCircles().destroy()

		addeventatc.settings({
			license: 'aAhxRcaHnzynVUcsmmfQ21064',
			css: false,
			facebook: {
				show: false,
				text: 'Facebook Event',
			},
		})

		saveGeolocation()
	},
}

window.submitSurveyAction = submitSurveyAction
window.tweet_share = tweet_share
window.fb_share = fb_share
// window.fb_shareV1 = fb_shareV1
window.testPopupSurvey = testPopupSurvey
window.popupReferral = popupReferral
